<template>
		<el-dialog title="新增字典" :visible.sync="visible" :before-close="beforeClose" width="70%">
				<el-form :model="form" inline style="margin-top: 30px;">
						<el-form-item label="类型">
								<el-input v-model="form.dictType" placeholder="请输入"></el-input>
						</el-form-item>
						
						<br>
						<el-col v-for="(item,index) in form.optionArray" :key="item.id">
								<el-form-item label="选项名称">
										<el-input v-model="item.name" type="text" autocomplete="off"
															class="text-width"></el-input>
								</el-form-item>
								
								<el-button @click="form.optionArray.push({name: '', id: Date.now()})" type="text">添加</el-button>
								<el-button @click="form.optionArray.splice(index,1)" type="text">删除</el-button>
						</el-col>

				</el-form>

				<div slot="footer" class="dialog-footer">
						<el-button @click="beforeClose">取消</el-button>
						<el-button type="primary" @click="onConfirm">保存</el-button>
				</div>
		</el-dialog>

</template>

<script>
import {BaseDictionaryNew} from "@/api/setting";
import {getToken} from "@/utils/auth";
import {mapGetters} from "vuex";

export default {
		name: "AddDataObjectDialog",
		components: {},
		computed: {
				...mapGetters(['BaseDictionaryList_typeDDL'])
		},
		props: ['visible','currentItem'],
		watch: {
				async visible(newValue) {
						// await this.$store.dispatch('source/getMediumList', );
				}
		},
		data() {
				return {
						form: {dictType: '', optionArray:[{name: '', id: Date.now()}] }
				};
		},
		methods: {
				async onConfirm() {
						console.log(this.form);
						const {dictType, optionArray} = this.form,
								xml = optionArray.filter(item => item.name.trim() ).map(item=>{
										return `<Item name="${item.name}" ></Item>`;
								}).join('');
						if (!xml) {
								this.$message.warning('请将选项名称补充完整');
								return;
						}
						await BaseDictionaryNew({userId:getToken(), dictType,xml});
						this.$message.success('添加成功');
						this.form = { optionArray:[{name: '',  id: Date.now()}]};
						this.beforeClose();
						await this.$store.dispatch('setting/BaseDictionaryList',);
				},
				beforeClose() {
						this.$emit('update:visible', false);
				}
		}
}
</script>

<style scoped>

</style>